// @flow
import React from 'react';
import classNames from 'classnames';
import IconBellWhite from 'assets/images/bell-white.png';
import IconBellPink from 'assets/images/bell-pink.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  onClick?: () => void,
  theme: string,
  className?: string,
  text: string,
  link?: string,
};
export const EventNotificationButton = (props: Props) => {
  const { className, theme, onClick, text, link } = props;
  const containerClassName = classNames(
    'event-notification-container',
    className,
    {
      dark: theme === 'dark-theme',
      light: theme === 'light-theme',
    }
  );
  const bellIcon = theme === 'dark-theme' ? IconBellWhite : IconBellPink;
  return (
    <a className={containerClassName} href={`#${link}`} onClick={onClick}>
      <button className="bell-icon">
        <img src={bellIcon} alt="Notification Icon" />
      </button>
      <span>{text}</span>
    </a>
  );
};
